export default "__VITE_ASSET__39b7769f__"